import React, { useEffect, useState } from "react";
import LiquidContainer from "../../components/LiquidContainer";
import MainLanding from "./MainLanding";
import { notifications } from "../../api/user";

const Notifications = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notificationsData, setNotificationsData] = useState([]);

  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleString();
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const data = await notifications();

        // console.log("Notificaciones:", data);

        setNotificationsData(data);
      } catch (err) {
        if (err.response?.status === 401 || err.response?.status === 403) {
          window.location.href = "/";
          return;
        }
        setError("Could not load notifications");
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <MainLanding>
      <LiquidContainer
        backgroundColor="#efefefe0"
        ancho="85vw"
        alto="75vh"
        borderline="0px"
        boxSdw="none"
      >
        <div
          className="d-flex flex-column align-items-center py-4"
          style={{
            height: "90%",
            width: "90%",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <h3 className="mb-4">Notificaciones</h3>

          {notificationsData.length === 0 ? (
            <p className="text-muted">No tienes notificaciones.</p>
          ) : (
            notificationsData.map((notification) => (
              <div
                key={notification.id}
                className="card mb-3 p-3 shadow-sm w-100"
              >
                <div className="d-flex justify-content-between align-items-start">
                  <h5 className="mb-1">{notification.title}</h5>
                  <small className="text-muted">
                    {formatDate(notification.created_at)}
                  </small>
                </div>

                <p className="mb-1">{notification.content}</p>

                {notification.expires_at && (
                  <small className="text-danger">
                    Expira: {formatDate(notification.expires_at)}
                  </small>
                )}
              </div>
            ))
          )}
        </div>
      </LiquidContainer>
    </MainLanding>
  );
};

export default Notifications;